import { useEffect, useRef, useState } from 'react';

export default function useHandleOrdersFetching({
  ordersToRetrieve,
  isLoading,
  index,
}) {
  const loadMoreBottomRef = useRef(true);
  const loadMoreTopRef = useRef(true);
  const scrollRef = useRef(null);

  const [orders, setOrders] = useState([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [ordersLoading, setOrdersLoading] = useState(false);

  const handleUpdateOrders = (orders) => setOrders(orders);

  // Hooks runs whenever orders are fetched
  useEffect(() => {
    const updateOrders = async () => {
      const ordersCopy = [...ordersToRetrieve];

      if (!loadMoreTopRef.current) {
        // Enters this statement if user tried to load orders in the top side of the scroll
        ordersCopy[14].ref = scrollRef;
        await handleUpdateOrders(ordersCopy);

        scrollRef.current.scrollIntoView();
        loadMoreTopRef.current = true;
      } else if (!loadMoreBottomRef.current) {
        // Enters this statement if user tried to load orders in the bottom side of the scroll
        ordersCopy[14].ref = scrollRef;
        await handleUpdateOrders(ordersCopy);

        scrollRef.current.scrollIntoView();
        loadMoreBottomRef.current = true;
      } else {
        // Enters this if in the first statement or when other filters excluding "page" are set
        await handleUpdateOrders(ordersCopy);
      }

      setOrdersLoading(false);
      setIsLoadingMore(false);
    };

    setOrdersLoading(true);
    if (!isLoading && ordersToRetrieve && ordersToRetrieve.length > 0) {
      updateOrders();
    } else if (
      !isLoading &&
      ordersToRetrieve &&
      ordersToRetrieve.length === 0
    ) {
      handleUpdateOrders([]);
      setOrdersLoading(false);
    }
  }, [ordersToRetrieve, isLoading, index]);

  return {
    loadMoreBottomRef,
    loadMoreTopRef,
    isLoadingMore,
    ordersLoading,
    setIsLoadingMore,
    handleUpdateOrders,
    orders,
  };
}
